import { render, staticRenderFns } from "./SortAmendment.vue?vue&type=template&id=69605c3d&scoped=true&"
import script from "./SortAmendment.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SortAmendment.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SortAmendment.vue?vue&type=style&index=0&id=69605c3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69605c3d",
  null
  
)

export default component.exports